import{
    GET_CLIENT_CONFIG,
    SET_CLIENT_CONFIG,
    CLEAR_CLIENT_CONFIG
} from '../actions/types';

const initialState = {
    loading: true,
    config: null
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_CLIENT_CONFIG:
      return {
        ...state,
        loading: true,
      };
    case SET_CLIENT_CONFIG:
      return {
        ...state,
        loading: false,
        config: payload
      };
    case CLEAR_CLIENT_CONFIG:
      return {
        ...state,
        loading: false,
        config: null
      };
    default:
      return state;
  }
}
